module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "textarea"
    }
  }, [_c('textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.settingsVisible),
      expression: "!settingsVisible"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.sayThis),
      expression: "sayThis"
    }],
    attrs: {
      "type": "text",
      "id": "sayThis",
      "rows": "2",
      "placeholder": _vm.$t('typeHere') + '...'
    },
    domProps: {
      "value": (_vm.sayThis)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sayThis = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "button-group",
    attrs: {
      "id": "divButtons"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.settingsVisible),
      expression: "!settingsVisible"
    }],
    staticClass: "large success button noselect",
    attrs: {
      "id": "btnTalk",
      "disabled": _vm.buttonsDisabled
    },
    on: {
      "click": function($event) {
        return _vm.talk()
      }
    }
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "font-size": "250%"
    },
    attrs: {
      "icon": "comment"
    }
  })], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.settingsVisible),
      expression: "!settingsVisible"
    }],
    staticClass: "large warning button noselect",
    attrs: {
      "id": "btnEdit",
      "disabled": _vm.buttonsDisabled
    },
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "font-size": "250%"
    },
    attrs: {
      "icon": "pen-to-square"
    }
  })], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.settingsVisible),
      expression: "!settingsVisible"
    }],
    staticClass: "large alert button noselect",
    attrs: {
      "id": "btnClear",
      "disabled": _vm.buttonsDisabled
    },
    on: {
      "click": function($event) {
        return _vm.clearInput()
      }
    }
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "font-size": "250%"
    },
    attrs: {
      "icon": "trash-can"
    }
  })], 1), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localVoices.length > 0),
      expression: "localVoices.length>0"
    }],
    staticClass: "large button noselect",
    class: {
      hollow: !_vm.settingsVisible
    },
    attrs: {
      "id": "btnSettings",
      "disabled": _vm.buttonsDisabled
    },
    on: {
      "click": function($event) {
        return _vm.settings()
      }
    }
  }, [_c('font-awesome-icon', {
    staticStyle: {
      "font-size": "250%"
    },
    attrs: {
      "icon": "sliders"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.settingsVisible),
      expression: "settingsVisible"
    }],
    attrs: {
      "id": "settings"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "medium-6 columns"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localVoices.length > 0),
      expression: "localVoices.length>0"
    }],
    staticClass: "medium-6 columns",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "voiceListContainer"
    }
  }, [_c('label', [_c('b', [_vm._v(_vm._s(_vm.$t('voice')) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedVoice),
      expression: "selectedVoice"
    }],
    attrs: {
      "id": "selectVoice"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedVoice = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.localVoices), function(voice) {
    return _c('option', {
      domProps: {
        "value": voice.name
      }
    }, [_vm._v("\n                " + _vm._s(voice.lang + ' ' + voice.name) + "\n              ")])
  }), 0)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cc8ac3c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Textbox.vue
// module id = 99
// module chunks = 2